<template>
	<div class="gb-members">
	</div>
</template>
<script>
export default {
	name: "GBMembers",
	props: [ "items", "max_width", "all_show" ],
	methods: {
		display: function() {
			while (this.$el.firstChild)
				this.$el.removeChild(this.$el.firstChild);
			let width = 0;
			for (let item of this.items) {
				let span = document.createElement('span');
				span.innerHTML = item.name;
				this.$el.appendChild(span);
				let span_width = span.offsetWidth + 3;	// add margin-right
				width += span_width;
				if (this.max_width < width) {
					if (this.all_show) {
						this.$el.insertBefore(document.createElement('br'), span);
						width = span_width;
					} else {
						span.innerHTML = ' &gt;&gt;';
						break;
					}
				}
			}
			if (this.items.length == 0) {
				let span = document.createElement('span');
				span.innerHTML = '&nbsp;';
				this.$el.appendChild(span);
			}
			return true;
		},
	},
	mounted: function() {
		this.display();
	},
	watch: {
		items: function() {
			this.display();
		},
	},
};
</script>
<style>
	.gb-members {
		width: 100%;
		overflow: hidden;
		/* text-overflow: ellipsis; */
		white-space: nowrap;
	}

	.gb-members > span {
		font-size: .75em;
		margin-right: 3px;
	}
</style>
